import { generalEnv } from '@nx-frontend/shared/env';

export const getBoxFileUrl = (UUID: string, params?: Record<string, string | number>): string | null => {
  let uriParams = '';
  if (params) {
    uriParams =
      '?' +
      Object.entries(params)
        .map(([key, val]) => `${key}=${val}`)
        .join('&');
  }
  return UUID ? `${generalEnv.staticAssetPrefix}${UUID}${uriParams}` : null;
};
